<template>
    <div id="demo-basic-card">
        <vx-card class="mb-base">
            <template   slot="actions">
                <vx-tooltip text="Add new module" position="left">
                    <feather-icon @click="redirectToAddPackage()" icon="EditIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                </vx-tooltip>
            </template>

            <div id="allModulesLoadingDiv" class="vs-con-loading__container">
                <div class="vx-row">
                    <div class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base" v-if="packagesData.length" v-for="(listItem, index) in packagesData" :key="index">
                        <vx-card>
                            <div slot="no-body">
                                <img :src="listItem.image" alt="content-img" class="responsive card-img-top">
                            </div>
                            <h5 class="mb-2">{{ listItem.name }}</h5>
                            <p class="text-grey">Price {{ listItem.cost }} </p>
                            <p class="text-grey">{{ listItem.modules.length }} Module(s)</p>
                            <div class="flex justify-between flex-wrap">
                                <vs-button @click="viewPackage(listItem)"class="mt-4 mr-2 shadow-lg" type="gradient" color="primary"  icon-pack="feather" icon="icon-menu" icon-after>View</vs-button>
                                <vs-button @click="editPackage(listItem)"class="mt-4 mr-2 shadow-lg" type="gradient" color="danger"  icon-pack="feather" icon="icon-edit" icon-after>Edit</vs-button>
                            </div>
                        </vx-card>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import modulePackageManagement from '@/store/package-management/modulePackageManagement.js'

export default{
    data() {
        return {
            packagesData: [],
        }
    },
    components: {
        VuePerfectScrollbar,
    },
    methods: {
        redirectToAddPackage() {
            this.$router.push("/packages/add").catch(() => {})
        },
        getLessionNumber(moduleData) {
            if(moduleData.lession_number && moduleData.lession_number.length){
                return 'Lession number - '+moduleData.lession_number.join(', ');
            }
            else return ""
        },
        getAllPackages() {
            // this.$vs.loading({
            //     container: '#allModulesLoadingDiv',
            //     scale: 0.6
            // })

            this.$store.dispatch("packageManagement/getAllPackages")
                .then(res => { 
                    this.packagesData = res.data
                    // this.$vs.loading.close('#allModulesLoadingDiv > .con-vs-loading')
                })
                .catch(err => { 
                    // this.$vs.loading.close('#allModulesLoadingDiv > .con-vs-loading')
                })
        },
        viewPackage(module) {
            this.$router.push("/packages/view/" + module.id).catch(() => {})
        },
        editPackage(module) {
            this.$router.push("/packages/edit/" + module.id).catch(() => {})
        },
    },
    created() {
        if(!modulePackageManagement.isRegistered) {
            this.$store.registerModule('packageManagement', modulePackageManagement)
            modulePackageManagement.isRegistered = true
        }

        this.packagesData = this.$store.state.packageManagement.packages
        this.getAllPackages()
    },

}
</script>

